import { render, staticRenderFns } from "./fltCard.vue?vue&type=template&id=18caf924&scoped=true&"
import script from "./fltCard.vue?vue&type=script&lang=js&"
export * from "./fltCard.vue?vue&type=script&lang=js&"
import style0 from "./fltCard.vue?vue&type=style&index=0&id=18caf924&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18caf924",
  null
  
)

export default component.exports